import { render, staticRenderFns } from "./IncomeCalculator.vue?vue&type=template&id=4bcf753f&lang=pug"
import script from "./IncomeCalculator.vue?vue&type=script&lang=js"
export * from "./IncomeCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports